export const getSearchQuery = (term: string) => {
  return [
    {
      wildcard: {
        UniqueLinkId_lower: {
          value: term,
        },
      },
    },
    {
      nested: {
        query: {
          wildcard: {
            'parameters.Value_lower': {
              value: term,
            },
          },
        },
        path: 'parameters',
      },
    },
    {
      nested: {
        query: {
          wildcard: {
            'urls.Url_lower': {
              value: term,
            },
          },
        },
        path: 'urls',
      },
    },
    {
      nested: {
        query: {
          wildcard: {
            'urls.ShortUrl_lower': {
              value: term,
            },
          },
        },
        path: 'urls',
      },
    },
    {
      nested: {
        query: {
          wildcard: {
            'urls.BatchCode_lower': {
              value: term,
            },
          },
        },
        path: 'urls',
      },
    },
  ];
};



// WEBPACK FOOTER //
// ./src/services/api/links/utils/getSearchQuery.ts